import CSS from './page-hero.module.css'

export const PageHero = ({ children }) => {
    return (
        <div className={CSS.layout}>
            <div className={CSS.heroGraphic}>
                <video src="/assets/theme/2027/2027-theme-animation.mp4" width={`100%`} muted autoPlay loop playsInline />
            </div>
            
            <section className={` ${CSS.descriptor} block`}>
                <div className="container">
                    { children }
                </div>
            </section>
        </div>
    )
}

